export default __webpack_public_path__ + "static/media/searchIcon.71b16035.gif";